$(document).ready(function() {
 // Function to update size descriptions within all elements with class 'beme_grid_vartion__inner'
    function updateAllSizeDescriptions() {
       $('.template-product-beme-panty .beme_grid_vartion__inner').each(function() {
            var spans = $(this).find('span[data-label-value=""]');
           spans.each(function() {
                let sizeText = $(this).text().trim();
               switch (sizeText) {
                    case 'S':
                        $(this).text('small');
                        break;
                    case 'M':
                        $(this).text('medium');
                        break;
                    case 'L':
                        $(this).text('large');
                        break;
                    case 'XL':
                        $(this).text('extra large');
                        break;
                        case '2XL':
                        $(this).text('double extra Large');
                        break;
                    default:
                        break;
                }
            });
        });
    }
  // Call the function on page load to ensure all sizes are updated initially
    updateAllSizeDescriptions();
  // Set up click event handling to update sizes no matter where the click occurs within the page
    $(document).on('click', function() {
        updateAllSizeDescriptions();
    });
});